"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSelectedValue = exports.filterOptions = exports.getSelectedOptionsTitles = void 0;

var _utils = require("../../utils");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var getSelectedOptionsTitles = function getSelectedOptionsTitles(allOptions, selectedOptions) {
  return allOptions && (0, _utils.transformOptions)(allOptions).filter(function (_ref) {
    var value = _ref.value;
    return selectedOptions && selectedOptions.indexOf && selectedOptions.indexOf(value) !== -1;
  }).map(function (_ref2) {
    var label = _ref2.label;
    return label;
  });
};

exports.getSelectedOptionsTitles = getSelectedOptionsTitles;

var filterOptions = function filterOptions(options, searchStr) {
  return (0, _utils.transformOptions)(options).filter(function (_ref3) {
    var label = _ref3.label;
    return label.toLowerCase().search(searchStr.toLowerCase()) !== -1;
  });
};

exports.filterOptions = filterOptions;

var getSelectedValue = function getSelectedValue(value) {
  return value !== null && _typeof(value) === 'object' ? value.value : value;
};

exports.getSelectedValue = getSelectedValue;